/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Label, Row, Col, Input, FormFeedback, Button, Modal, ModalHeader, ModalBody, FormGroup,
  ModalFooter } from 'reactstrap'

import {AppContext} from '../AppContext';

class AssociateGateway extends React.Component
{
  async associateGateway(event)
  {
    let bodyData = {};
    bodyData.gatewayName = this.state.gatewayName;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'findGateway', bodyData);
    if ('success' !== result.status && this.context.dbTwig.GatewayOffline !== result.errorCode)
    {
      this.setState({gatewayEnabled: 'N', updateButtonDisabled: true});
      return this.context.dbTwig.apiErrorHandler(result, 'Error finding gateway');
    } 

    if ('success' !== result.status && this.context.dbTwig.GatewayOffline === result.errorCode)
      this.context.postNotification('warning', 'Gateway offline.');

    if ('success' === result.status)
    {
      this.context.postNotification('info', 'Gateway online.');
      this.props.closeModal(result.jsonData.gatewayName);
    }
  }

  cancelModal(event)
  {
    this.props.closeModal('');
  }

  constructor(props)
  {
    super();

    this.state =
    {
      buttonDisabled: true,
      gatewayName: '',
      gatewayNameValid: undefined
    }

    this.onKeyDown = this.onKeyDown.bind(this);
    this.associateGateway = this.associateGateway.bind(this);
    this.cancelModal = this.cancelModal.bind(this);
    this.setGatewayName = this.setGatewayName.bind(this);
  }

  onKeyDown(event)
  {
    if (window.enterKeyPressed(event.keyCode) && !this.state.buttonDisabled) this.associateGateway(event);
  }

  render()
  {
    return(
      <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal} autoFocus={false} >
        <ModalHeader toggle={this.cancelModal}>Associate DbObscura Gateway</ModalHeader>
        <ModalBody>
          <Row style={{paddingTop: '10px'}}><Col>Enter the name of your DbObscura Gateway Client.</Col></Row>
          <FormGroup style={{paddingTop: '10px'}} row>
            <Label sm="3" for='gatewayName'>Gateway Name</Label>
            <Col sm="8" >
              <Input type="text" id="gatewayName" placeholder="Gateway Name..." value={this.state.gatewayName} 
                onChange={this.setGatewayName}
                invalid={(undefined === this.state.gatewayNameValid ? undefined : !this.state.gatewayNameValid)} 
                valid={(undefined === this.state.gatewayNameValid ? undefined : this.state.gatewayNameValid)} 
                onKeyDown={this.onKeyDown}
              />
              <FormFeedback valid={false}>Please specify your DbObscura Gateway client name.</FormFeedback>
            </Col>
          </FormGroup>          
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.associateGateway} disabled={this.state.buttonDisabled}>Associate Gateway</Button>
          <Button autoFocus color="secondary" onClick={this.cancelModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }

  setGatewayName(event)
  {
    let disabled = ('' === event.target.value ? true : false);
    this.setState({gatewayName: event.target.value, buttonDisabled: disabled});
  }
}

AssociateGateway.contextType = AppContext;

export default AssociateGateway